module.exports = __webpack_public_path__ + "img/scene-safe.0858da4e.png";